import React from "react";

const DeliveryPolicy = () => {
  document.title = "Delivery policy";
  return (
    <>
      <div className="container my-5">
        <h5>Shipping and Delivery Policy</h5>
        <p>
          At Yuva Sarathi, we strive to provide a seamless experience for
          participants attending industry events through our platform. This
          Shipping and Delivery Policy outlines the guidelines and processes for
          accessing event materials and services.
        </p>
        <ol>
          <li>
            <b> Access to Event Materials: </b>Upon successful registration for
            an industry event through our platform, participants will have
            access to digital event tickets for download. Event tickets can be
            downloaded directly from the user's dashboard upon login.
          </li>
          <li>
            <b> Event Ticket Download Process:</b> After logging in to their
            account, participants can navigate to the "My Tickets" or similar
            section to access their event tickets. Event tickets will be
            available for download in a printable PDF format.
          </li>
          <li>
            <b> No Shipping Facilities Available:</b> Please note that we do not
            offer shipping facilities for event tickets. All event materials are
            provided digitally through our platform.
          </li>
          <li>
            <b> Ticket Verification: </b>Participants are required to present
            their downloaded event tickets (in digital or printed format) for
            verification at the event venue. Event tickets contain unique
            identifiers to ensure authenticity and prevent duplication.
          </li>

          <p className="my-3">
            Contact Us: &nbsp; If you encounter any issues or require assistance
            with downloading your event tickets, please contact our support team
            at yuvasarathi24@gmail.com or 9371001138
          </p>
        </ol>
      </div>
    </>
  );
};

export default DeliveryPolicy;
